// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface RESTTeamsSearchOptions
 */
export interface RESTTeamsSearchOptions {
    /**
     * Specifies the type of Microsoft Teams items that you want to find.
     * @type {string}
     * @memberof RESTTeamsSearchOptions
     */
    type: RESTTeamsSearchOptionsTypeEnum;
    /**
     * Specifies query parameters used to search for Microsoft Teams items. For the complete list of supported query parameters, see the [Appendix A. Item Search Parameters](https://helpcenter.veeam.com/docs/vbo365/guide/appendix_search.html?ver=80) section of the Veeam Backup for Microsoft 365 User Guide.
     * @type {string}
     * @memberof RESTTeamsSearchOptions
     */
    query: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTTeamsSearchOptionsTypeEnum {
    Tabs = 'Tabs',
    Files = 'Files',
    Posts = 'Posts'
}

